<h1 mat-dialog-title>Confermi di voler aggiornare la tabella?</h1>
<div mat-dialog-content>
  <p>Confermi di voler aggiornare tblVariazioneSottostanteAppo? L'operazione potrebbe richiedere qualche minuto</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()">Conferma</button>
  <button mat-button (click)="onNoClick()">Cancella</button>
</div>
